const breakpoints = {
  mobile: 768,
  tablet: 1440,
};

export const isMobile = () => window.innerWidth < breakpoints.mobile;
export const isTablet = () =>
  window.innerWidth >= breakpoints.mobile && window.innerWidth < breakpoints.tablet;
export const isDesktop = () => window.innerWidth >= breakpoints.tablet;